import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetodapolicab() {



    const cardData = {

keyword: "Pune to Dapoli Cab",

headingDescription:
    "Rising Cab Service offers safe, comfortable, and reliable Pune to Dapoli Cab services for families, couples, and coastal travelers. We provide well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury vehicles with experienced chauffeurs for a smooth and scenic journey from Pune to the Konkan region. Our service includes doorstep pickup, flexible one-way and round-trip options, 24/7 support, and transparent pricing, ensuring a relaxing travel experience to Dapoli’s beaches, hills, and coastal attractions.",

topPlaces: [
    {
        title: "Karde Beach",
        description:
            "Karde Beach is one of the most popular beaches near Dapoli known for its long, clean shoreline and peaceful environment. It is ideal for dolphin spotting, relaxing walks, and enjoying sunrise and sunset views over the Arabian Sea. The calm waves and less crowded atmosphere make it perfect for family vacations and nature lovers."
    },
    {
        title: "Murud Beach (Dapoli)",
        description:
            "Murud Beach near Dapoli is a beautiful stretch of golden sand surrounded by coconut trees and scenic coastal views. It is known for its clean surroundings, water sports activities, and peaceful atmosphere, making it a favorite weekend getaway destination from Pune."
    },
    {
        title: "Ladghar Beach",
        description:
            "Ladghar Beach, also known as ‘Tamas Teertha’, is famous for its red sand and stunning sunset views. The beach offers a unique coastal experience with calm waves and is ideal for photography, relaxation, and quiet seaside walks."
    },
    {
        title: "Anjarle Beach & Turtle Festival",
        description:
            "Anjarle Beach is famous for Olive Ridley turtle nesting and conservation activities during the breeding season. It is a clean and serene beach surrounded by hills and coconut groves, attracting nature lovers and eco-tourism travelers."
    },
    {
        title: "Keshavraj Temple",
        description:
            "Keshavraj Temple is a peaceful hillside temple near Dapoli dedicated to Lord Vishnu. The trek to the temple passes through lush greenery, streams, and scenic landscapes, making it both a spiritual and nature-filled experience."
    },
    {
        title: "Harnai Port & Fish Market",
        description:
            "Harnai Port is a busy fishing hub near Dapoli known for its fresh seafood market and coastal lifestyle. Visitors can experience authentic Konkan fishing culture and enjoy fresh seafood directly from the local catch."
    },
    {
        title: "Suvarnadurg Fort",
        description:
            "Suvarnadurg Fort is a historic sea fort located near Harnai coast, built during the Maratha era. Accessible by boat, it offers strong architectural remains and panoramic views of the Arabian Sea, making it a must-visit heritage site."
    },
    {
        title: "Panhalekaji Caves",
        description:
            "Panhalekaji Caves are ancient rock-cut Buddhist caves located near Dapoli, surrounded by forested hills. These caves feature carvings, sculptures, and spiritual significance, making them an important historical attraction in the region."
    },
    {
        title: "Dabhol Port Area",
        description:
            "Dabhol is a coastal port area near Dapoli known for its scenic river estuary and ferry connections. It offers beautiful water landscapes and a glimpse into traditional Konkan maritime life."
    },
    {
        title: "Konkan Coastal Drive Route",
        description:
            "The Pune to Dapoli route via the Konkan highway is filled with lush green valleys, mountain curves, rivers, and coastal views. The journey itself is a highlight, offering a refreshing and scenic cab travel experience through the Western Ghats."
    }
],



services: [
  {
    name: "Pune to Dapoli Cab",
    description: "Rising Cab Service offers reliable Pune to Dapoli Cab service for a safe, scenic, and comfortable Konkan coastal journey to Dapoli beach destination. Ideal for families, couples, and groups, our service includes well-maintained AC vehicles, experienced long-route drivers, doorstep pickup from Pune, flexible travel timing, and 24x7 booking support. Enjoy a smooth highway drive through lush Konkan routes with complete comfort, transparent pricing, and a stress-free travel experience."
  },
  {
    name: "Pune to Dapoli Taxi",
    description: "Book Pune to Dapoli Taxi with Rising Cab Service for a comfortable and hassle-free journey to the serene Dapoli coastal town. We provide clean sanitized vehicles, professional chauffeurs, and safe driving across highways and Konkan routes. Perfect for weekend trips, family vacations, beach holidays, and resort stays with flexible pickup and drop options."
  },
  {
    name: "Cab from Pune to Dapoli",
    description: "Hire Cab from Pune to Dapoli for convenient door-to-door travel with complete flexibility and comfort. Choose from sedans, SUVs, and Innova Crysta based on your group size and travel needs. Our experienced drivers ensure safe coastal travel with smooth rides, scenic stops, and complete travel assistance throughout the journey."
  },
  {
    name: "Taxi from Pune to Dapoli",
    description: "Taxi from Pune to Dapoli service ensures punctual pickup, professional driving, and a safe long-distance journey to the Konkan beach region. Ideal for family vacations, resort transfers, and weekend getaways, our taxis offer AC comfort, affordable pricing, and reliable service."
  },
  {
    name: "Pune to Dapoli Cab Service",
    description: "Our Pune to Dapoli Cab Service provides complete travel solutions including pickup, drop, sightseeing flexibility, and return options. We focus on safety, comfort, and affordability with trained drivers, well-maintained vehicles, and 24x7 booking assistance for a smooth Konkan travel experience."
  },
  {
    name: "Pune to Dapoli Taxi Fare",
    description: "Get transparent Pune to Dapoli Taxi Fare with clear and affordable pricing based on vehicle type and travel plan. We offer budget-friendly and premium options for sedans, SUVs, and Innova Crysta with no hidden charges, ensuring value-for-money travel for long coastal routes."
  },
  {
    name: "Pune to Dapoli One Way Cab",
    description: "Book Pune to Dapoli One Way Cab for economical drop-only travel to the scenic Konkan coast. Ideal for solo travelers and families, this service includes AC vehicles, professional drivers, and smooth highway travel at affordable rates without return charges."
  },
  {
    name: "Pune to Dapoli Round Trip Taxi",
    description: "Pune to Dapoli Round Trip Taxi service is perfect for beach vacations and resort stays. It includes flexible return scheduling, waiting time, comfortable vehicles, and experienced drivers for a complete round-trip travel experience."
  },
  {
    name: "Pune to Dapoli Cab Booking",
    description: "Easy Pune to Dapoli Cab Booking system for instant reservations with multiple vehicle choices including Sedan, SUV, Innova Crysta, and Tempo Traveller. Get quick confirmation, transparent pricing, and 24x7 customer support."
  },
  {
    name: "Cheap Pune to Dapoli Cab",
    description: "Affordable Cheap Pune to Dapoli Cab service for budget travelers who want economical yet safe coastal travel. We provide low-cost fares, clean vehicles, and professional drivers without compromising comfort or safety."
  },
  {
    name: "Best Pune to Dapoli Taxi",
    description: "Choose Best Pune to Dapoli Taxi service for premium travel experience with top-rated drivers, comfortable vehicles, and smooth highway driving through scenic Konkan routes."
  },
  {
    name: "Sedan Pune to Dapoli Cab",
    description: "Sedan Pune to Dapoli Cab service is ideal for solo travelers, couples, and small families seeking budget-friendly and comfortable long-distance travel."
  },
  {
    name: "SUV Pune to Dapoli Taxi",
    description: "Book SUV Pune to Dapoli Taxi for group travel requiring extra space and comfort. Our SUVs are perfect for Konkan routes, offering smooth rides and strong road performance."
  },
  {
    name: "Innova Pune to Dapoli Cab",
    description: "Premium Innova Pune to Dapoli Cab service for families and groups seeking luxury, comfort, and spacious seating for long coastal journeys."
  },
  {
    name: "Konkan Cab Pune Dapoli",
    description: "Konkan Cab Pune Dapoli service is specially designed for exploring Konkan beaches and scenic routes with flexible itineraries and comfortable long-distance travel."
  },
  {
    name: "Dapoli Cab from Pune",
    description: "Dapoli Cab from Pune service offers direct door-to-door travel to the beach town with safe driving and flexible travel plans."
  },
  {
    name: "Pune to Dapoli Beach Cab",
    description: "Pune to Dapoli Beach Cab service ensures a smooth and scenic coastal journey with professional drivers and comfortable vehicles for a relaxing beach trip."
  },
  {
    name: "Pune to Dapoli Tourist Cab Service",
    description: "Pune to Dapoli Tourist Cab Service provides complete travel solutions for tourists exploring Konkan beaches, resorts, and nearby attractions."
  },
  {
    name: "Pune to Dapoli Innova Taxi",
    description: "Pune to Dapoli Innova Taxi service offers premium comfort for families and groups with spacious seating and smooth long-distance travel experience."
  },
  {
    name: "Pune to Dapoli Travel Package",
    description: "Pune to Dapoli Travel Package includes pickup, resort transfers, beach visits, sightseeing, and return journey for a complete hassle-free vacation experience."
  },
  {
    name: "Pune to Dapoli Long Distance Taxi",
    description: "Pune to Dapoli Long Distance Taxi service ensures safe, comfortable, and reliable highway travel with experienced drivers and well-maintained vehicles."
  },
  {
    name: "Pune to Dapoli Door to Door Cab",
    description: "Pune to Dapoli Door to Door Cab service provides convenient pickup and drop from your exact location for a seamless travel experience."
  },
  {
    name: "Pune to Dapoli Resort Transfer",
    description: "Pune to Dapoli Resort Transfer service ensures smooth and timely pickup and drop to coastal resorts with comfortable vehicles and professional drivers."
  },
  {
    name: "Pune to Murud Beach Dapoli Taxi",
    description: "Pune to Murud Beach Dapoli Taxi service offers direct travel to Murud and nearby Dapoli beaches with safe and comfortable long-distance rides."
  },
  {
    name: "Pune to Karde Beach Cab",
    description: "Pune to Karde Beach Cab service ensures scenic travel to Karde beach with flexible stops and comfortable AC vehicles for a relaxing trip."
  },
  {
    name: "Pune to Ladghar Beach Cab",
    description: "Pune to Ladghar Beach Cab service provides smooth travel to Ladghar beach with experienced drivers and well-maintained vehicles."
  },
  {
    name: "Pune to Konkan Tour Cab",
    description: "Pune to Konkan Tour Cab service offers complete coastal travel packages covering multiple beaches, forts, and sightseeing destinations."
  },
  {
    name: "Pune to Dapoli Beach Tour",
    description: "Pune to Dapoli Beach Tour provides a complete travel experience covering beaches, resorts, and scenic Konkan routes."
  },
  {
    name: "Pune to Dapoli Family Trip Cab",
    description: "Pune to Dapoli Family Trip Cab is designed for safe and enjoyable family travel with spacious vehicles and customized itineraries."
  },
  {
    name: "Pune to Dapoli Tourist Taxi",
    description: "Pune to Dapoli Tourist Taxi service provides reliable travel for tourists exploring Dapoli beaches and nearby attractions."
  },
  {
    name: "Pune to Dapoli Holiday Package",
    description: "Pune to Dapoli Holiday Package offers complete travel solutions for weekend and holiday trips with sightseeing and comfortable cab service included."
  }
],

tableData: [
  ["Pune to Dapoli Cab", "Pune to Dapoli Taxi"],
  ["Cab from Pune to Dapoli", "Taxi from Pune to Dapoli"],
  ["Pune to Dapoli Cab Service", "Pune to Dapoli Taxi Fare"],
  ["Pune to Dapoli One Way Cab", "Pune to Dapoli Round Trip Taxi"],
  ["Pune to Dapoli Cab Booking", "Cheap Pune to Dapoli Cab"],
  ["Best Pune to Dapoli Taxi", "Sedan Pune to Dapoli Cab"],
  ["SUV Pune to Dapoli Taxi", "Innova Pune to Dapoli Cab"],
  ["Konkan Cab Pune Dapoli", "Dapoli Cab from Pune"],
  ["Pune to Dapoli Beach Cab", "Pune to Dapoli Travel Package"],
  ["Pune to Dapoli Resort Transfer", "Pune to Dapoli Family Trip Cab"]
],



whychoose: [
    {
        WhyChooseheading: "Reliable Pune to Dapoli Cab Service",
        WhyChoosedescription: "Rising Cab Service provides comfortable Pune to Dapoli cab transportation for families, tourists, couples, beach lovers, and Konkan holiday travelers."
    },
    {
        WhyChooseheading: "Perfect for Konkan Beach Vacations",
        WhyChoosedescription: "Dapoli is one of Maharashtra's most loved coastal destinations, known for beautiful beaches, dolphin spotting, sea views, and peaceful surroundings."
    },
    {
        WhyChooseheading: "Ideal for Weekend Getaways and Family Trips",
        WhyChoosedescription: "Whether planning a beach holiday, family vacation, honeymoon trip, or sightseeing tour, we offer flexible travel options for every traveler."
    },
    {
        WhyChooseheading: "Comfortable Vehicles for Every Journey",
        WhyChoosedescription: "Choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles according to your travel needs and group size."
    },
    {
        WhyChooseheading: "Visit Famous Attractions Around Dapoli",
        WhyChoosedescription: "Travel conveniently to Murud Beach, Karde Beach, Ladghar Beach, Harnai Port, Suvarnadurg Fort, Panhalekaji Caves, and nearby tourist attractions."
    },
    {
        WhyChooseheading: "Doorstep Pickup Across Pune & PCMC",
        WhyChoosedescription: "Pickup services are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and surrounding areas."
    },
    {
        WhyChooseheading: "Safe Travel Through Scenic Konkan Routes",
        WhyChoosedescription: "Our experienced drivers ensure smooth travel through coastal roads and ghat sections while providing a safe and enjoyable journey."
    },
    {
        WhyChooseheading: "Suitable for Couples, Families, and Groups",
        WhyChoosedescription: "Rising Cab Service caters to honeymoon trips, family holidays, beach vacations, corporate outings, and group tours."
    }
]
};

const faqData = [
    {
        question: "Why is Dapoli a popular tourist destination from Pune?",
        answer: "Dapoli is famous for its beaches, dolphin sightseeing, Konkan cuisine, historical attractions, and relaxing coastal atmosphere."
    },
    {
        question: "Can I book a one-way cab from Pune to Dapoli?",
        answer: "Yes, one-way cab services are available along with round-trip and customized Konkan travel packages."
    },
    {
        question: "Which attractions can be visited during a Dapoli trip?",
        answer: "Popular attractions include Murud Beach, Karde Beach, Ladghar Beach, Harnai Port, Suvarnadurg Fort, Panhalekaji Caves, and Dolphin Point."
    },
    {
        question: "Which vehicle is suitable for a family trip to Dapoli?",
        answer: "Ertiga and Innova Crysta are among the most preferred options because they provide comfortable seating and ample luggage space."
    },
    {
        question: "Do you provide Tempo Travellers for group tours?",
        answer: "Yes, Tempo Travellers and larger vehicles are available for family groups, corporate outings, and tourist groups."
    },
    {
        question: "Can Dapoli and Harihareshwar be covered in one trip?",
        answer: "Yes, customized itineraries can include Dapoli, Harihareshwar, Shrivardhan, Diveagar, and other Konkan destinations."
    },
    {
        question: "Are weekend holiday packages available for Dapoli?",
        answer: "Yes, customers can choose weekend tours, overnight stays, and multi-day Konkan holiday packages."
    },
    {
        question: "Can beach sightseeing and dolphin watching be included?",
        answer: "Yes, travel plans can include beach visits, dolphin safaris, water activities, and local sightseeing attractions."
    },
    {
        question: "Are pickups available from Pune Airport and Railway Station?",
        answer: "Yes, pickups can be arranged from Pune Airport, Railway Station, hotels, offices, and residential locations."
    },
    {
        question: "How can I book a Pune to Dapoli Cab?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Rohan Chavan",
        feedback:
            "Our Dapoli beach vacation was absolutely fantastic. The cab was clean, the ride was comfortable, and we enjoyed visiting multiple beaches without any travel worries.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Snehal Gokhale",
        feedback:
            "The Konkan trip to Dapoli was planned perfectly. From dolphin watching to beach sightseeing, everything was smooth and enjoyable thanks to the excellent travel arrangements.",
        rating: 5
    }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];









const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Dapoli Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-dapoli-cab.jpg",
"description": "Book Pune to Dapoli Cab Service with Rising Cab Service for safe and comfortable coastal travel. Enjoy reliable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars for family beach trips and weekend getaways.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-dapoli-cab"
}
};









    return (
        <div>

<Helmet>
  <title>Pune to Dapoli Cab Service | Coastal Taxi Booking | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Dapoli Cab Service for safe and comfortable coastal travel. Get affordable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars for beach trips and holidays."
/>

<meta
 name="keywords"
 content="pune to dapoli cab, pune to dapoli taxi, cab from pune to dapoli, taxi from pune to dapoli, pune to dapoli cab service, pune to dapoli taxi fare, pune to dapoli one way cab, pune to dapoli round trip taxi, pune to dapoli cab booking, cheap pune to dapoli cab, best pune to dapoli taxi, sedan pune to dapoli cab, suv pune to dapoli cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>


            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/108.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetodapolicab;